import React from 'react'
import { AuthorizationActions } from '../userAccount/actionNames'
import { ModalActions } from './actionNames'
import initialStore from './initialStore'
import openModal from './mutators/openModal'
import closeModal from './mutators/closeModal'

export default function(
  store: Readonly<IModalStore> = initialStore,
  action: any,
) {
  switch (action.type) {
    case ModalActions.OpenModalRedux:
      return openModal(store, action)
    case ModalActions.CloseModal:
      return closeModal(store, action)
    case ModalActions.ToggleHideModal:
      return {
        ...store,
        hideModal: action.payload,
      }
    case ModalActions.OpenTooltip:
      return {
        ...store,
        tooltips: [...store.tooltips, action.id],
      }
    case ModalActions.CloseTooltip:
      return {
        ...store,
        tooltips: [...store.tooltips.filter(id => id !== action.id)],
      }
    case ModalActions.CloseTooltips:
      return { ...store, tooltips: [] }
    case AuthorizationActions.FlushState:
      return {
        modals: [],
        tooltips: [],
      }
  }

  return store
}

export interface IModalStore {
  modals: IModal[]
  tooltips: string[]
  hideModal: boolean
}

export interface IModal {
  id: string
  element: React.ReactElement
}
